var _g, _g2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaltelCorporateSpeedChangeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.911 16.696a9.608 9.608 0 0 0-5.834-2.768h-.042A9.535 9.535 0 0 0 9.2 16.696a1.928 1.928 0 0 0 0 2.725c.127.128.27.242.426.313a1.918 1.918 0 0 0 2.3-.313 5.713 5.713 0 0 1 3.136-1.604 5.723 5.723 0 0 1 5.01 1.604 1.5 1.5 0 0 0 .427.313 1.928 1.928 0 0 0 .412-3.038zm5.437-5.437C23.21 8.122 19.18 6.461 15.063 6.234A17.175 17.175 0 0 0 3.764 11.26a1.928 1.928 0 0 0 0 2.726c.128.127.27.227.412.298.738.44 1.689.326 2.3-.298a13.474 13.474 0 0 1 8.573-3.918 13.45 13.45 0 0 1 10.461 3.918c.128.127.27.227.426.312a1.928 1.928 0 0 0 .412-3.038z",
    fill: "url(#2eu26qmrpa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.036 24.858a2.9 2.9 0 0 1-1.987 2.768 2.933 2.933 0 0 1-1.973-2.768c0-1.278.823-2.37 1.973-2.768a2.9 2.9 0 0 1 1.987 2.768z",
    fill: "url(#wm7i1d1xtb)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.354 9.868c-.554.425-1.079.88-1.59 1.377a1.928 1.928 0 0 0 0 2.725c.128.128.27.227.412.298.738.44 1.689.326 2.3-.298l.085-.085C5.58 12.82 5.184 11.3 5.354 9.854v.014z",
    fill: "url(#jdr00q8npc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.748 15.503c-.554.34-1.079.71-1.561 1.192a1.928 1.928 0 0 0 0 2.726c.127.127.27.241.425.312a1.89 1.89 0 0 0 2.2-.241c-.908-1.08-1.263-2.57-1.078-3.99h.014z",
    fill: "url(#rs8f7d1gbd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.19 22.16s-.098-.056-.141-.07a2.932 2.932 0 0 0-1.973 2.767c0 1.278.823 2.37 1.973 2.768.227-.07.426-.198.61-.312-1.05-1.448-1.192-3.506-.468-5.139v-.014z",
    fill: "url(#xs3sd25d0e)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.475 13.974c5.252-5.252 13.783-5.252 19.035 0a1.928 1.928 0 0 0 2.726-2.726c-6.757-6.742-17.73-6.742-24.472.015a1.928 1.928 0 0 0 2.726 2.725l-.015-.014zm5.437 5.436a5.766 5.766 0 0 1 8.162 0 1.928 1.928 0 0 0 2.725-2.725c-3.747-3.747-9.837-3.747-13.598 0a1.928 1.928 0 0 0 2.725 2.725h-.014z",
    stroke: "url(#5unaqbed6f)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.923a2.92 2.92 0 0 1 2.924 2.924A2.92 2.92 0 0 1 16 27.77a2.92 2.92 0 0 1-2.924-2.924A2.92 2.92 0 0 1 16 21.923z",
    stroke: "url(#berabmyfyg)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.613 30.824v-9.467c0-.376-.434.01-.763.231a.56.56 0 0 0-.09.075l-2.032 2.109m6.79-2.45v8.353c0 .376.007 1.097.294.983a.262.262 0 0 0 .083-.06l2.445-2.396",
    stroke: "url(#epgx5jlpjh)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2eu26qmrpa",
    x1: 20.795,
    y1: 39.085,
    x2: -2.662,
    y2: 28.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wm7i1d1xtb",
    x1: 20.795,
    y1: 39.085,
    x2: -2.662,
    y2: 28.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jdr00q8npc",
    x1: 12.445,
    y1: 37.146,
    x2: -1.176,
    y2: 33.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rs8f7d1gbd",
    x1: 12.445,
    y1: 37.146,
    x2: -1.176,
    y2: 33.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xs3sd25d0e",
    x1: 12.445,
    y1: 37.146,
    x2: -1.176,
    y2: 33.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5unaqbed6f",
    x1: 22.196,
    y1: 39.33,
    x2: -2.557,
    y2: 27.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "berabmyfyg",
    x1: 22.196,
    y1: 39.33,
    x2: -2.557,
    y2: 27.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "epgx5jlpjh",
    x1: 8.86,
    y1: 35.98,
    x2: -0.941,
    y2: 32.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaltelCorporateSpeedChangeIcon);
export default __webpack_public_path__ + "static/media/paltelCorporateSpeedChangeIcon.071a511961ac1173efe7ed1ff62faaaa.svg";
export { ForwardRef as ReactComponent };